(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3b41"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3b41"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hw3jF", function(module, exports) {
/*!
  * Bootstrap data.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const elementMap = new Map();
    const data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element); // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key); // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    return data;
});

});

parcelRegister("8EQUk", function(module, exports) {
/*!
  * Bootstrap event-handler.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    const customEventsRegex = /^(mouseenter|mouseleave)/i;
    const nativeEvents = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    /**
   * ------------------------------------------------------------------------
   * Private methods
   * ------------------------------------------------------------------------
   */ function getUidEvent(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getEvent(element) {
        const uid = getUidEvent(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            event.delegateTarget = element;
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode){
                for(let i = domElements.length; i--;)if (domElements[i] === target) {
                    event.delegateTarget = target;
                    if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                    return fn.apply(target, [
                        event
                    ]);
                }
            } // To please ESLint
            return null;
        };
    }
    function findHandler(events, handler, delegationSelector = null) {
        const uidEventList = Object.keys(events);
        for(let i = 0, len = uidEventList.length; i < len; i++){
            const event = events[uidEventList[i]];
            if (event.originalHandler === handler && event.delegationSelector === delegationSelector) return event;
        }
        return null;
    }
    function normalizeParams(originalTypeEvent, handler, delegationFn) {
        const delegation = typeof handler === "string";
        const originalHandler = delegation ? delegationFn : handler;
        let typeEvent = getTypeEvent(originalTypeEvent);
        const isNative = nativeEvents.has(typeEvent);
        if (!isNative) typeEvent = originalTypeEvent;
        return [
            delegation,
            originalHandler,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        if (!handler) {
            handler = delegationFn;
            delegationFn = null;
        } // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (customEventsRegex.test(originalTypeEvent)) {
            const wrapFn = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            if (delegationFn) delegationFn = wrapFn(delegationFn);
            else handler = wrapFn(handler);
        }
        const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
        const events = getEvent(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);
        if (previousFn) {
            previousFn.oneOff = previousFn.oneOff && oneOff;
            return;
        }
        const uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ""));
        const fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
        fn.delegationSelector = delegation ? handler : null;
        fn.originalHandler = originalHandler;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, delegation);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        Object.keys(storeElementEvent).forEach((handlerKey)=>{
            if (handlerKey.includes(namespace)) {
                const event = storeElementEvent[handlerKey];
                removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
            }
        });
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, "");
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFn) {
            addHandler(element, event, handler, delegationFn, false);
        },
        one (element, event, handler, delegationFn) {
            addHandler(element, event, handler, delegationFn, true);
        },
        off (element, originalTypeEvent, handler, delegationFn) {
            if (typeof originalTypeEvent !== "string" || !element) return;
            const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getEvent(element);
            const isNamespace = originalTypeEvent.startsWith(".");
            if (typeof originalHandler !== "undefined") {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!events || !events[typeEvent]) return;
                removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
                return;
            }
            if (isNamespace) Object.keys(events).forEach((elementEvent)=>{
                removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            });
            const storeElementEvent = events[typeEvent] || {};
            Object.keys(storeElementEvent).forEach((keyHandlers)=>{
                const handlerKey = keyHandlers.replace(stripUidRegex, "");
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
                    const event = storeElementEvent[keyHandlers];
                    removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
                }
            });
        },
        trigger (element, event, args) {
            if (typeof event !== "string" || !element) return null;
            const $ = getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            const isNative = nativeEvents.has(typeEvent);
            let jQueryEvent;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            let evt = null;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            if (isNative) {
                evt = document.createEvent("HTMLEvents");
                evt.initEvent(typeEvent, bubbles, true);
            } else evt = new CustomEvent(event, {
                bubbles: bubbles,
                cancelable: true
            });
             // merge custom information in our event
            if (typeof args !== "undefined") Object.keys(args).forEach((key)=>{
                Object.defineProperty(evt, key, {
                    get () {
                        return args[key];
                    }
                });
            });
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && typeof jQueryEvent !== "undefined") jQueryEvent.preventDefault();
            return evt;
        }
    };
    return EventHandler;
});

});

parcelRegister("9XHSj", function(module, exports) {
/*!
  * Bootstrap manipulator.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(val) {
        if (val === "true") return true;
        if (val === "false") return false;
        if (val === Number(val).toString()) return Number(val);
        if (val === "" || val === "null") return null;
        return val;
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            Object.keys(element.dataset).filter((key)=>key.startsWith("bs")).forEach((key)=>{
                let pureKey = key.replace(/^bs/, "");
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            });
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        },
        offset (element) {
            const rect = element.getBoundingClientRect();
            return {
                top: rect.top + window.pageYOffset,
                left: rect.left + window.pageXOffset
            };
        },
        position (element) {
            return {
                top: element.offsetTop,
                left: element.offsetLeft
            };
        }
    };
    return Manipulator;
});

});

parcelRegister("cajOs", function(module, exports) {
/*!
  * Bootstrap selector-engine.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        return getComputedStyle(element).getPropertyValue("visibility") === "visible";
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const NODE_TEXT = 3;
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode;
            while(ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT){
                if (ancestor.matches(selector)) parents.push(ancestor);
                ancestor = ancestor.parentNode;
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(", ");
            return this.find(focusables, element).filter((el)=>!isDisabled(el) && isVisible(el));
        }
    };
    return SelectorEngine;
});

});

parcelRegister("hJBCI", function(module, exports) {


/*!
  * Bootstrap base-component.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("hw3jF")), (parcelRequire("8EQUk")));
})(module.exports, function(Data, EventHandler) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const Data__default = /*#__PURE__*/ _interopDefaultLegacy(Data);
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = "transitionend"; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
         // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
         // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(",")[0];
        transitionDelay = transitionDelay.split(",")[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const execute = (callback)=>{
        if (typeof callback === "function") callback();
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const VERSION = "5.1.3";
    class BaseComponent {
        constructor(element){
            element = getElement(element);
            if (!element) return;
            this._element = element;
            Data__default.default.set(this._element, this.constructor.DATA_KEY, this);
        }
        dispose() {
            Data__default.default.remove(this._element, this.constructor.DATA_KEY);
            EventHandler__default.default.off(this._element, this.constructor.EVENT_KEY);
            Object.getOwnPropertyNames(this).forEach((propertyName)=>{
                this[propertyName] = null;
            });
        }
        _queueCallback(callback, element, isAnimated = true) {
            executeAfterTransition(callback, element, isAnimated);
        }
        /** Static */ static getInstance(element) {
            return Data__default.default.get(getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
    }
    return BaseComponent;
});

});

parcelRegister("85GS9", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("1XeKD")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("bRGCp")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("1XeKD")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("1i5KE")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("6ZtBQ")).createPopper; });

var $cLyCg = parcelRequire("cLyCg");

var $5OD3Q = parcelRequire("5OD3Q");

var $1XeKD = parcelRequire("1XeKD");
var $bRGCp = parcelRequire("bRGCp");

var $1i5KE = parcelRequire("1i5KE");

var $6ZtBQ = parcelRequire("6ZtBQ");
$parcel$exportWildcard(module.exports, $cLyCg);
$parcel$exportWildcard(module.exports, $5OD3Q);

});
parcelRegister("cLyCg", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $94b4b9e13683876b$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $94b4b9e13683876b$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $94b4b9e13683876b$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $94b4b9e13683876b$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $94b4b9e13683876b$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $94b4b9e13683876b$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $94b4b9e13683876b$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $94b4b9e13683876b$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $94b4b9e13683876b$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $94b4b9e13683876b$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $94b4b9e13683876b$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $94b4b9e13683876b$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $94b4b9e13683876b$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $94b4b9e13683876b$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $94b4b9e13683876b$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $94b4b9e13683876b$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $94b4b9e13683876b$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $94b4b9e13683876b$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $94b4b9e13683876b$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $94b4b9e13683876b$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $94b4b9e13683876b$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $94b4b9e13683876b$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $94b4b9e13683876b$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $94b4b9e13683876b$export$d087d3878fdf71d5; });
var $94b4b9e13683876b$export$1e95b668f3b82d = "top";
var $94b4b9e13683876b$export$40e543e69a8b3fbb = "bottom";
var $94b4b9e13683876b$export$79ffe56a765070d2 = "right";
var $94b4b9e13683876b$export$eabcd2c8791e7bf4 = "left";
var $94b4b9e13683876b$export$dfb5619354ba860 = "auto";
var $94b4b9e13683876b$export$aec2ce47c367b8c3 = [
    $94b4b9e13683876b$export$1e95b668f3b82d,
    $94b4b9e13683876b$export$40e543e69a8b3fbb,
    $94b4b9e13683876b$export$79ffe56a765070d2,
    $94b4b9e13683876b$export$eabcd2c8791e7bf4
];
var $94b4b9e13683876b$export$b3571188c770cc5a = "start";
var $94b4b9e13683876b$export$bd5df0f255a350f8 = "end";
var $94b4b9e13683876b$export$390fd549c5303b4d = "clippingParents";
var $94b4b9e13683876b$export$d7b7311ec04a3e8f = "viewport";
var $94b4b9e13683876b$export$ae5ab1c730825774 = "popper";
var $94b4b9e13683876b$export$ca50aac9f3ba507f = "reference";
var $94b4b9e13683876b$export$368f9a87e87fa4e1 = /*#__PURE__*/ $94b4b9e13683876b$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $94b4b9e13683876b$export$b3571188c770cc5a,
        placement + "-" + $94b4b9e13683876b$export$bd5df0f255a350f8
    ]);
}, []);
var $94b4b9e13683876b$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($94b4b9e13683876b$export$aec2ce47c367b8c3, [
    $94b4b9e13683876b$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $94b4b9e13683876b$export$b3571188c770cc5a,
        placement + "-" + $94b4b9e13683876b$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $94b4b9e13683876b$export$421679a7c3d56e = "beforeRead";
var $94b4b9e13683876b$export$aafa59e2e03f2942 = "read";
var $94b4b9e13683876b$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $94b4b9e13683876b$export$c65e99957a05207c = "beforeMain";
var $94b4b9e13683876b$export$f22da7240b7add18 = "main";
var $94b4b9e13683876b$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $94b4b9e13683876b$export$8d4d2d70e7d46032 = "beforeWrite";
var $94b4b9e13683876b$export$68d8715fc104d294 = "write";
var $94b4b9e13683876b$export$70a6e5159acce2e6 = "afterWrite";
var $94b4b9e13683876b$export$d087d3878fdf71d5 = [
    $94b4b9e13683876b$export$421679a7c3d56e,
    $94b4b9e13683876b$export$aafa59e2e03f2942,
    $94b4b9e13683876b$export$6964f6c886723980,
    $94b4b9e13683876b$export$c65e99957a05207c,
    $94b4b9e13683876b$export$f22da7240b7add18,
    $94b4b9e13683876b$export$bab79516f2d662fe,
    $94b4b9e13683876b$export$8d4d2d70e7d46032,
    $94b4b9e13683876b$export$68d8715fc104d294,
    $94b4b9e13683876b$export$70a6e5159acce2e6
];

});

parcelRegister("5OD3Q", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("5go8m")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("iI5M1")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("ikLF4")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("4K4GL")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("d9QP5")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("jf3Ds")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("jOnSG")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("9ZC9k")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("hzijY")).default; });

var $5go8m = parcelRequire("5go8m");

var $iI5M1 = parcelRequire("iI5M1");

var $ikLF4 = parcelRequire("ikLF4");

var $4K4GL = parcelRequire("4K4GL");

var $d9QP5 = parcelRequire("d9QP5");

var $jf3Ds = parcelRequire("jf3Ds");

var $jOnSG = parcelRequire("jOnSG");

var $9ZC9k = parcelRequire("9ZC9k");

var $hzijY = parcelRequire("hzijY");

});
parcelRegister("5go8m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d512ade8c91ebfb$export$2e2bcd8739ae039; });

var $6NkGB = parcelRequire("6NkGB");

var $1RVTs = parcelRequire("1RVTs");
// and applies them to the HTMLElements such as popper and arrow
function $3d512ade8c91ebfb$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1RVTs.isHTMLElement)(element) || !(0, $6NkGB.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $3d512ade8c91ebfb$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1RVTs.isHTMLElement)(element) || !(0, $6NkGB.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $3d512ade8c91ebfb$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $3d512ade8c91ebfb$var$applyStyles,
    effect: $3d512ade8c91ebfb$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRegister("6NkGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f275d86f3ede410$export$2e2bcd8739ae039; });
function $4f275d86f3ede410$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("1RVTs", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $15c7a61ffd8e36a4$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $15c7a61ffd8e36a4$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $15c7a61ffd8e36a4$export$af51f0f06c0f328a; });

var $6VeU8 = parcelRequire("6VeU8");
function $15c7a61ffd8e36a4$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6VeU8.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $15c7a61ffd8e36a4$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6VeU8.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $15c7a61ffd8e36a4$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6VeU8.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("6VeU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50a3a0a50aa47cf1$export$2e2bcd8739ae039; });
function $50a3a0a50aa47cf1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRegister("iI5M1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f0d09206d4e200$export$2e2bcd8739ae039; });

var $3FlPd = parcelRequire("3FlPd");

var $4SfcU = parcelRequire("4SfcU");

var $4f9St = parcelRequire("4f9St");

var $5yRd2 = parcelRequire("5yRd2");

var $vnCoq = parcelRequire("vnCoq");

var $bqlya = parcelRequire("bqlya");

var $5CB4p = parcelRequire("5CB4p");

var $hjGnZ = parcelRequire("hjGnZ");

var $cLyCg = parcelRequire("cLyCg");
var $d9f0d09206d4e200$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5CB4p.default)(typeof padding !== "number" ? padding : (0, $hjGnZ.default)(padding, (0, $cLyCg.basePlacements)));
};
function $d9f0d09206d4e200$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3FlPd.default)(state.placement);
    var axis = (0, $vnCoq.default)(basePlacement);
    var isVertical = [
        (0, $cLyCg.left),
        (0, $cLyCg.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $d9f0d09206d4e200$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4SfcU.default)(arrowElement);
    var minProp = axis === "y" ? (0, $cLyCg.top) : (0, $cLyCg.left);
    var maxProp = axis === "y" ? (0, $cLyCg.bottom) : (0, $cLyCg.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5yRd2.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $bqlya.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $d9f0d09206d4e200$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4f9St.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $d9f0d09206d4e200$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $d9f0d09206d4e200$var$arrow,
    effect: $d9f0d09206d4e200$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("3FlPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ab621692c44dbed$export$2e2bcd8739ae039; });

function $2ab621692c44dbed$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("4SfcU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38c8006e367b9e69$export$2e2bcd8739ae039; });

var $fGVST = parcelRequire("fGVST");
function $38c8006e367b9e69$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $fGVST.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("fGVST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6c7ade38f998663$export$2e2bcd8739ae039; });

var $1RVTs = parcelRequire("1RVTs");

var $5h5GL = parcelRequire("5h5GL");

var $6VeU8 = parcelRequire("6VeU8");

var $kZB3M = parcelRequire("kZB3M");
function $b6c7ade38f998663$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1RVTs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $5h5GL.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $5h5GL.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1RVTs.isElement)(element) ? (0, $6VeU8.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $kZB3M.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("5h5GL", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $3d72f3f8ce3cae73$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $3d72f3f8ce3cae73$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $3d72f3f8ce3cae73$export$2077e0241d6afd3c; });
var $3d72f3f8ce3cae73$export$8960430cfd85939f = Math.max;
var $3d72f3f8ce3cae73$export$96ec731ed4dcb222 = Math.min;
var $3d72f3f8ce3cae73$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("kZB3M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f486407bd221696b$export$2e2bcd8739ae039; });

var $gu6Lj = parcelRequire("gu6Lj");
function $f486407bd221696b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $gu6Lj.default)());
}

});
parcelRegister("gu6Lj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c004b180b09eb189$export$2e2bcd8739ae039; });
function $c004b180b09eb189$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("4f9St", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $317039a16befd628$export$2e2bcd8739ae039; });

var $1RVTs = parcelRequire("1RVTs");
function $317039a16befd628$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1RVTs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("5yRd2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40c966f9761e8c00$export$2e2bcd8739ae039; });

var $6VeU8 = parcelRequire("6VeU8");

var $6NkGB = parcelRequire("6NkGB");

var $bNJ7c = parcelRequire("bNJ7c");

var $1RVTs = parcelRequire("1RVTs");

var $9rb8V = parcelRequire("9rb8V");

var $hYyel = parcelRequire("hYyel");

var $gu6Lj = parcelRequire("gu6Lj");
function $40c966f9761e8c00$var$getTrueOffsetParent(element) {
    if (!(0, $1RVTs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $bNJ7c.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $40c966f9761e8c00$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $gu6Lj.default)());
    var isIE = /Trident/i.test((0, $gu6Lj.default)());
    if (isIE && (0, $1RVTs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $bNJ7c.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $hYyel.default)(element);
    if ((0, $1RVTs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1RVTs.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $6NkGB.default)(currentNode)) < 0){
        var css = (0, $bNJ7c.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $40c966f9761e8c00$export$2e2bcd8739ae039(element) {
    var window = (0, $6VeU8.default)(element);
    var offsetParent = $40c966f9761e8c00$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $9rb8V.default)(offsetParent) && (0, $bNJ7c.default)(offsetParent).position === "static")offsetParent = $40c966f9761e8c00$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6NkGB.default)(offsetParent) === "html" || (0, $6NkGB.default)(offsetParent) === "body" && (0, $bNJ7c.default)(offsetParent).position === "static")) return window;
    return offsetParent || $40c966f9761e8c00$var$getContainingBlock(element) || window;
}

});
parcelRegister("bNJ7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89774440832126ed$export$2e2bcd8739ae039; });

var $6VeU8 = parcelRequire("6VeU8");
function $89774440832126ed$export$2e2bcd8739ae039(element) {
    return (0, $6VeU8.default)(element).getComputedStyle(element);
}

});

parcelRegister("9rb8V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6def47713bc88946$export$2e2bcd8739ae039; });

var $6NkGB = parcelRequire("6NkGB");
function $6def47713bc88946$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $6NkGB.default)(element)) >= 0;
}

});

parcelRegister("hYyel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d16297af602df68c$export$2e2bcd8739ae039; });

var $6NkGB = parcelRequire("6NkGB");

var $euyM6 = parcelRequire("euyM6");

var $1RVTs = parcelRequire("1RVTs");
function $d16297af602df68c$export$2e2bcd8739ae039(element) {
    if ((0, $6NkGB.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1RVTs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $euyM6.default)(element) // fallback
    );
}

});
parcelRegister("euyM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8ced7919fde52ee$export$2e2bcd8739ae039; });

var $1RVTs = parcelRequire("1RVTs");
function $a8ced7919fde52ee$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1RVTs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("vnCoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05e5377499ea85d2$export$2e2bcd8739ae039; });
function $05e5377499ea85d2$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("bqlya", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $8512d6cefc88a416$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $8512d6cefc88a416$export$86c8af6d3ef0b4a; });

var $5h5GL = parcelRequire("5h5GL");
function $8512d6cefc88a416$export$f28d906d67a997f3(min, value, max) {
    return (0, $5h5GL.max)(min, (0, $5h5GL.min)(value, max));
}
function $8512d6cefc88a416$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8512d6cefc88a416$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("5CB4p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $417d41b8559e4bdc$export$2e2bcd8739ae039; });

var $2UH44 = parcelRequire("2UH44");
function $417d41b8559e4bdc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2UH44.default)(), paddingObject);
}

});
parcelRegister("2UH44", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21f2377662d3fa13$export$2e2bcd8739ae039; });
function $21f2377662d3fa13$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hjGnZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9b5170041606ef7$export$2e2bcd8739ae039; });
function $c9b5170041606ef7$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("ikLF4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d58f10d519b1b7b1$export$2e2bcd8739ae039; });

var $cLyCg = parcelRequire("cLyCg");

var $5yRd2 = parcelRequire("5yRd2");

var $6VeU8 = parcelRequire("6VeU8");

var $euyM6 = parcelRequire("euyM6");

var $bNJ7c = parcelRequire("bNJ7c");

var $3FlPd = parcelRequire("3FlPd");

var $9NB0H = parcelRequire("9NB0H");

var $5h5GL = parcelRequire("5h5GL");
var $d58f10d519b1b7b1$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $d58f10d519b1b7b1$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $5h5GL.round)(x * dpr) / dpr || 0,
        y: (0, $5h5GL.round)(y * dpr) / dpr || 0
    };
}
function $d58f10d519b1b7b1$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $cLyCg.left);
    var sideY = (0, $cLyCg.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5yRd2.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6VeU8.default)(popper)) {
            offsetParent = (0, $euyM6.default)(popper);
            if ((0, $bNJ7c.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cLyCg.top) || (placement === (0, $cLyCg.left) || placement === (0, $cLyCg.right)) && variation === (0, $cLyCg.end)) {
            sideY = (0, $cLyCg.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cLyCg.left) || (placement === (0, $cLyCg.top) || placement === (0, $cLyCg.bottom)) && variation === (0, $cLyCg.end)) {
            sideX = (0, $cLyCg.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $d58f10d519b1b7b1$var$unsetSides);
    var _ref4 = roundOffsets === true ? $d58f10d519b1b7b1$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6VeU8.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $d58f10d519b1b7b1$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3FlPd.default)(state.placement),
        variation: (0, $9NB0H.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $d58f10d519b1b7b1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $d58f10d519b1b7b1$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d58f10d519b1b7b1$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $d58f10d519b1b7b1$var$computeStyles,
    data: {}
};

});
parcelRegister("9NB0H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72256625ed6002bc$export$2e2bcd8739ae039; });
function $72256625ed6002bc$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("4K4GL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $373f18652de3812b$export$2e2bcd8739ae039; });

var $6VeU8 = parcelRequire("6VeU8");
var $373f18652de3812b$var$passive = {
    passive: true
};
function $373f18652de3812b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6VeU8.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $373f18652de3812b$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $373f18652de3812b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $373f18652de3812b$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $373f18652de3812b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $373f18652de3812b$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $373f18652de3812b$var$effect,
    data: {}
};

});

parcelRegister("d9QP5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99451731c3d54ac6$export$2e2bcd8739ae039; });

var $hAnYy = parcelRequire("hAnYy");

var $3FlPd = parcelRequire("3FlPd");

var $kOiHm = parcelRequire("kOiHm");

var $bRGCp = parcelRequire("bRGCp");

var $6cQDw = parcelRequire("6cQDw");

var $cLyCg = parcelRequire("cLyCg");

var $9NB0H = parcelRequire("9NB0H");
function $99451731c3d54ac6$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3FlPd.default)(placement) === (0, $cLyCg.auto)) return [];
    var oppositePlacement = (0, $hAnYy.default)(placement);
    return [
        (0, $kOiHm.default)(placement),
        oppositePlacement,
        (0, $kOiHm.default)(oppositePlacement)
    ];
}
function $99451731c3d54ac6$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3FlPd.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $hAnYy.default)(preferredPlacement)
    ] : $99451731c3d54ac6$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3FlPd.default)(placement) === (0, $cLyCg.auto) ? (0, $6cQDw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3FlPd.default)(placement);
        var isStartVariation = (0, $9NB0H.default)(placement) === (0, $cLyCg.start);
        var isVertical = [
            (0, $cLyCg.top),
            (0, $cLyCg.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $bRGCp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cLyCg.right) : (0, $cLyCg.left) : isStartVariation ? (0, $cLyCg.bottom) : (0, $cLyCg.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $hAnYy.default)(mainVariationSide);
        var altVariationSide = (0, $hAnYy.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $99451731c3d54ac6$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $99451731c3d54ac6$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("hAnYy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccd86586cf18929f$export$2e2bcd8739ae039; });
var $ccd86586cf18929f$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $ccd86586cf18929f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $ccd86586cf18929f$var$hash[matched];
    });
}

});

parcelRegister("kOiHm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f266fb401b364ff3$export$2e2bcd8739ae039; });
var $f266fb401b364ff3$var$hash = {
    start: "end",
    end: "start"
};
function $f266fb401b364ff3$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f266fb401b364ff3$var$hash[matched];
    });
}

});

parcelRegister("bRGCp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a35b415ac3bec79$export$2e2bcd8739ae039; });

var $cjYYh = parcelRequire("cjYYh");

var $euyM6 = parcelRequire("euyM6");

var $fGVST = parcelRequire("fGVST");

var $fXJQB = parcelRequire("fXJQB");

var $fYHHw = parcelRequire("fYHHw");

var $cLyCg = parcelRequire("cLyCg");

var $1RVTs = parcelRequire("1RVTs");

var $5CB4p = parcelRequire("5CB4p");

var $hjGnZ = parcelRequire("hjGnZ");
function $8a35b415ac3bec79$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cLyCg.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cLyCg.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cLyCg.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5CB4p.default)(typeof padding !== "number" ? padding : (0, $hjGnZ.default)(padding, (0, $cLyCg.basePlacements)));
    var altContext = elementContext === (0, $cLyCg.popper) ? (0, $cLyCg.reference) : (0, $cLyCg.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $cjYYh.default)((0, $1RVTs.isElement)(element) ? element : element.contextElement || (0, $euyM6.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $fGVST.default)(state.elements.reference);
    var popperOffsets = (0, $fXJQB.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $fYHHw.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cLyCg.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cLyCg.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cLyCg.right),
                (0, $cLyCg.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cLyCg.top),
                (0, $cLyCg.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("cjYYh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f868dfdab1acd33$export$2e2bcd8739ae039; });

var $cLyCg = parcelRequire("cLyCg");

var $kRma8 = parcelRequire("kRma8");

var $2dtv7 = parcelRequire("2dtv7");

var $79WwS = parcelRequire("79WwS");

var $5yRd2 = parcelRequire("5yRd2");

var $euyM6 = parcelRequire("euyM6");

var $bNJ7c = parcelRequire("bNJ7c");

var $1RVTs = parcelRequire("1RVTs");

var $fGVST = parcelRequire("fGVST");

var $hYyel = parcelRequire("hYyel");

var $4f9St = parcelRequire("4f9St");

var $6NkGB = parcelRequire("6NkGB");

var $fYHHw = parcelRequire("fYHHw");

var $5h5GL = parcelRequire("5h5GL");
function $8f868dfdab1acd33$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $fGVST.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $8f868dfdab1acd33$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cLyCg.viewport) ? (0, $fYHHw.default)((0, $kRma8.default)(element, strategy)) : (0, $1RVTs.isElement)(clippingParent) ? $8f868dfdab1acd33$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fYHHw.default)((0, $2dtv7.default)((0, $euyM6.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $8f868dfdab1acd33$var$getClippingParents(element) {
    var clippingParents = (0, $79WwS.default)((0, $hYyel.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $bNJ7c.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1RVTs.isHTMLElement)(element) ? (0, $5yRd2.default)(element) : element;
    if (!(0, $1RVTs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1RVTs.isElement)(clippingParent) && (0, $4f9St.default)(clippingParent, clipperElement) && (0, $6NkGB.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $8f868dfdab1acd33$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $8f868dfdab1acd33$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $8f868dfdab1acd33$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $5h5GL.max)(rect.top, accRect.top);
        accRect.right = (0, $5h5GL.min)(rect.right, accRect.right);
        accRect.bottom = (0, $5h5GL.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $5h5GL.max)(rect.left, accRect.left);
        return accRect;
    }, $8f868dfdab1acd33$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("kRma8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2f9f2e4b69fdc5c$export$2e2bcd8739ae039; });

var $6VeU8 = parcelRequire("6VeU8");

var $euyM6 = parcelRequire("euyM6");

var $kHRKy = parcelRequire("kHRKy");

var $kZB3M = parcelRequire("kZB3M");
function $f2f9f2e4b69fdc5c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6VeU8.default)(element);
    var html = (0, $euyM6.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $kZB3M.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $kHRKy.default)(element),
        y: y
    };
}

});
parcelRegister("kHRKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1318466e6a03f12$export$2e2bcd8739ae039; });

var $fGVST = parcelRequire("fGVST");

var $euyM6 = parcelRequire("euyM6");

var $kHdm7 = parcelRequire("kHdm7");
function $f1318466e6a03f12$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $fGVST.default)((0, $euyM6.default)(element)).left + (0, $kHdm7.default)(element).scrollLeft;
}

});
parcelRegister("kHdm7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1122ef5c2debc6e$export$2e2bcd8739ae039; });

var $6VeU8 = parcelRequire("6VeU8");
function $f1122ef5c2debc6e$export$2e2bcd8739ae039(node) {
    var win = (0, $6VeU8.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("2dtv7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19d3adf26fc35406$export$2e2bcd8739ae039; });

var $euyM6 = parcelRequire("euyM6");

var $bNJ7c = parcelRequire("bNJ7c");

var $kHRKy = parcelRequire("kHRKy");

var $kHdm7 = parcelRequire("kHdm7");

var $5h5GL = parcelRequire("5h5GL");
function $19d3adf26fc35406$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $euyM6.default)(element);
    var winScroll = (0, $kHdm7.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $5h5GL.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $5h5GL.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $kHRKy.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $bNJ7c.default)(body || html).direction === "rtl") x += (0, $5h5GL.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("79WwS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5366c65f5c9714c8$export$2e2bcd8739ae039; });

var $6xMhg = parcelRequire("6xMhg");

var $hYyel = parcelRequire("hYyel");

var $6VeU8 = parcelRequire("6VeU8");

var $gwQNR = parcelRequire("gwQNR");
function $5366c65f5c9714c8$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6xMhg.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6VeU8.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $gwQNR.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5366c65f5c9714c8$export$2e2bcd8739ae039((0, $hYyel.default)(target)));
}

});
parcelRegister("6xMhg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c3b46062febf7df$export$2e2bcd8739ae039; });

var $hYyel = parcelRequire("hYyel");

var $gwQNR = parcelRequire("gwQNR");

var $6NkGB = parcelRequire("6NkGB");

var $1RVTs = parcelRequire("1RVTs");
function $4c3b46062febf7df$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $6NkGB.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1RVTs.isHTMLElement)(node) && (0, $gwQNR.default)(node)) return node;
    return $4c3b46062febf7df$export$2e2bcd8739ae039((0, $hYyel.default)(node));
}

});
parcelRegister("gwQNR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0889822af9b8125$export$2e2bcd8739ae039; });

var $bNJ7c = parcelRequire("bNJ7c");
function $c0889822af9b8125$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $bNJ7c.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("fYHHw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba1e5bb3e0ec6ab1$export$2e2bcd8739ae039; });
function $ba1e5bb3e0ec6ab1$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("fXJQB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9efee0f9710b37d$export$2e2bcd8739ae039; });

var $3FlPd = parcelRequire("3FlPd");

var $9NB0H = parcelRequire("9NB0H");

var $vnCoq = parcelRequire("vnCoq");

var $cLyCg = parcelRequire("cLyCg");
function $b9efee0f9710b37d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3FlPd.default)(placement) : null;
    var variation = placement ? (0, $9NB0H.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cLyCg.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cLyCg.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cLyCg.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cLyCg.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $vnCoq.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $cLyCg.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cLyCg.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("6cQDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $484cb190fc13898c$export$2e2bcd8739ae039; });

var $9NB0H = parcelRequire("9NB0H");

var $cLyCg = parcelRequire("cLyCg");

var $bRGCp = parcelRequire("bRGCp");

var $3FlPd = parcelRequire("3FlPd");
function $484cb190fc13898c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cLyCg.placements) : _options$allowedAutoP;
    var variation = (0, $9NB0H.default)(placement);
    var placements = variation ? flipVariations ? (0, $cLyCg.variationPlacements) : (0, $cLyCg.variationPlacements).filter(function(placement) {
        return (0, $9NB0H.default)(placement) === variation;
    }) : (0, $cLyCg.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $bRGCp.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3FlPd.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("jf3Ds", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0223cf9d8a86386$export$2e2bcd8739ae039; });

var $cLyCg = parcelRequire("cLyCg");

var $bRGCp = parcelRequire("bRGCp");
function $e0223cf9d8a86386$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $e0223cf9d8a86386$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cLyCg.top),
        (0, $cLyCg.right),
        (0, $cLyCg.bottom),
        (0, $cLyCg.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $e0223cf9d8a86386$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $bRGCp.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $bRGCp.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $e0223cf9d8a86386$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $e0223cf9d8a86386$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $e0223cf9d8a86386$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $e0223cf9d8a86386$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0223cf9d8a86386$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $e0223cf9d8a86386$var$hide
};

});

parcelRegister("jOnSG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c5361eb5961cfe$export$2e2bcd8739ae039; });

var $3FlPd = parcelRequire("3FlPd");

var $cLyCg = parcelRequire("cLyCg");
function $e6c5361eb5961cfe$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3FlPd.default)(placement);
    var invertDistance = [
        (0, $cLyCg.left),
        (0, $cLyCg.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cLyCg.left),
        (0, $cLyCg.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $e6c5361eb5961cfe$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cLyCg.placements).reduce(function(acc, placement) {
        acc[placement] = $e6c5361eb5961cfe$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $e6c5361eb5961cfe$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $e6c5361eb5961cfe$var$offset
};

});

parcelRegister("9ZC9k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7467673fd5a9f9ca$export$2e2bcd8739ae039; });

var $fXJQB = parcelRequire("fXJQB");
function $7467673fd5a9f9ca$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $fXJQB.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7467673fd5a9f9ca$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $7467673fd5a9f9ca$var$popperOffsets,
    data: {}
};

});

parcelRegister("hzijY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca3eabc5f7b60ff$export$2e2bcd8739ae039; });

var $cLyCg = parcelRequire("cLyCg");

var $3FlPd = parcelRequire("3FlPd");

var $vnCoq = parcelRequire("vnCoq");

var $hvK0w = parcelRequire("hvK0w");

var $bqlya = parcelRequire("bqlya");

var $4SfcU = parcelRequire("4SfcU");

var $5yRd2 = parcelRequire("5yRd2");

var $bRGCp = parcelRequire("bRGCp");

var $9NB0H = parcelRequire("9NB0H");

var $2UH44 = parcelRequire("2UH44");

var $5h5GL = parcelRequire("5h5GL");
function $cca3eabc5f7b60ff$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $bRGCp.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3FlPd.default)(state.placement);
    var variation = (0, $9NB0H.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $vnCoq.default)(basePlacement);
    var altAxis = (0, $hvK0w.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $cLyCg.top) : (0, $cLyCg.left);
        var altSide = mainAxis === "y" ? (0, $cLyCg.bottom) : (0, $cLyCg.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cLyCg.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cLyCg.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4SfcU.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $2UH44.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $bqlya.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5yRd2.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $bqlya.within)(tether ? (0, $5h5GL.min)(min, tetherMin) : min, offset, tether ? (0, $5h5GL.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $cLyCg.top) : (0, $cLyCg.left);
        var _altSide = mainAxis === "x" ? (0, $cLyCg.bottom) : (0, $cLyCg.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cLyCg.top),
            (0, $cLyCg.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $bqlya.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $bqlya.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cca3eabc5f7b60ff$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $cca3eabc5f7b60ff$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("hvK0w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbf90509f1bf1435$export$2e2bcd8739ae039; });
function $cbf90509f1bf1435$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});



parcelRegister("1XeKD", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $16c6be6e6d4fabcd$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $16c6be6e6d4fabcd$export$8f7491d57c8f97a9; });

var $j0kt7 = parcelRequire("j0kt7");

var $4SfcU = parcelRequire("4SfcU");

var $79WwS = parcelRequire("79WwS");

var $5yRd2 = parcelRequire("5yRd2");

var $6tuWN = parcelRequire("6tuWN");

var $75OHS = parcelRequire("75OHS");

var $juK9y = parcelRequire("juK9y");

var $bRGCp = parcelRequire("bRGCp");

var $1RVTs = parcelRequire("1RVTs");
var $16c6be6e6d4fabcd$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $16c6be6e6d4fabcd$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $16c6be6e6d4fabcd$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $16c6be6e6d4fabcd$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $16c6be6e6d4fabcd$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1RVTs.isElement)(reference) ? (0, $79WwS.default)(reference) : reference.contextElement ? (0, $79WwS.default)(reference.contextElement) : [],
                    popper: (0, $79WwS.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $6tuWN.default)((0, $juK9y.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$16c6be6e6d4fabcd$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $j0kt7.default)(reference, (0, $5yRd2.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $4SfcU.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $75OHS.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$16c6be6e6d4fabcd$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $16c6be6e6d4fabcd$export$8f7491d57c8f97a9 = /*#__PURE__*/ $16c6be6e6d4fabcd$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("j0kt7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd5de50c8647ee03$export$2e2bcd8739ae039; });

var $fGVST = parcelRequire("fGVST");

var $iHM3o = parcelRequire("iHM3o");

var $6NkGB = parcelRequire("6NkGB");

var $1RVTs = parcelRequire("1RVTs");

var $kHRKy = parcelRequire("kHRKy");

var $euyM6 = parcelRequire("euyM6");

var $gwQNR = parcelRequire("gwQNR");

var $5h5GL = parcelRequire("5h5GL");
function $dd5de50c8647ee03$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $5h5GL.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $5h5GL.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dd5de50c8647ee03$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1RVTs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1RVTs.isHTMLElement)(offsetParent) && $dd5de50c8647ee03$var$isElementScaled(offsetParent);
    var documentElement = (0, $euyM6.default)(offsetParent);
    var rect = (0, $fGVST.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6NkGB.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $gwQNR.default)(documentElement)) scroll = (0, $iHM3o.default)(offsetParent);
        if ((0, $1RVTs.isHTMLElement)(offsetParent)) {
            offsets = (0, $fGVST.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $kHRKy.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("iHM3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9e18497ccbc9596$export$2e2bcd8739ae039; });

var $kHdm7 = parcelRequire("kHdm7");

var $6VeU8 = parcelRequire("6VeU8");

var $1RVTs = parcelRequire("1RVTs");

var $72tYR = parcelRequire("72tYR");
function $d9e18497ccbc9596$export$2e2bcd8739ae039(node) {
    if (node === (0, $6VeU8.default)(node) || !(0, $1RVTs.isHTMLElement)(node)) return (0, $kHdm7.default)(node);
    else return (0, $72tYR.default)(node);
}

});
parcelRegister("72tYR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51fff9d5970f0899$export$2e2bcd8739ae039; });
function $51fff9d5970f0899$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("6tuWN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b6d74fc2a8e6dda$export$2e2bcd8739ae039; });

var $cLyCg = parcelRequire("cLyCg");
function $4b6d74fc2a8e6dda$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $4b6d74fc2a8e6dda$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $4b6d74fc2a8e6dda$var$order(modifiers); // order based on phase
    return (0, $cLyCg.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("75OHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52a0555012847f5d$export$2e2bcd8739ae039; });
function $52a0555012847f5d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("juK9y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3149eb78952a14c$export$2e2bcd8739ae039; });
function $e3149eb78952a14c$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("1i5KE", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $0f0bef0128a1d76f$export$8f7491d57c8f97a9; });

var $1XeKD = parcelRequire("1XeKD");

var $4K4GL = parcelRequire("4K4GL");

var $9ZC9k = parcelRequire("9ZC9k");

var $ikLF4 = parcelRequire("ikLF4");

var $5go8m = parcelRequire("5go8m");

var $jOnSG = parcelRequire("jOnSG");

var $d9QP5 = parcelRequire("d9QP5");

var $hzijY = parcelRequire("hzijY");

var $iI5M1 = parcelRequire("iI5M1");

var $jf3Ds = parcelRequire("jf3Ds");


var $0f0bef0128a1d76f$export$d34966752335dd47 = [
    (0, $4K4GL.default),
    (0, $9ZC9k.default),
    (0, $ikLF4.default),
    (0, $5go8m.default),
    (0, $jOnSG.default),
    (0, $d9QP5.default),
    (0, $hzijY.default),
    (0, $iI5M1.default),
    (0, $jf3Ds.default)
];
var $0f0bef0128a1d76f$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1XeKD.popperGenerator)({
    defaultModifiers: $0f0bef0128a1d76f$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRegister("6ZtBQ", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $516f686864bb49c7$export$8f7491d57c8f97a9; });

var $1XeKD = parcelRequire("1XeKD");

var $4K4GL = parcelRequire("4K4GL");

var $9ZC9k = parcelRequire("9ZC9k");

var $ikLF4 = parcelRequire("ikLF4");

var $5go8m = parcelRequire("5go8m");
var $516f686864bb49c7$export$d34966752335dd47 = [
    (0, $4K4GL.default),
    (0, $9ZC9k.default),
    (0, $ikLF4.default),
    (0, $5go8m.default)
];
var $516f686864bb49c7$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1XeKD.popperGenerator)({
    defaultModifiers: $516f686864bb49c7$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


//
// Scripts
//
var $a18748251e2fede6$exports = {};





/*!
  * Bootstrap collapse.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $a18748251e2fede6$exports = factory((parcelRequire("hw3jF")), (parcelRequire("8EQUk")), (parcelRequire("9XHSj")), (parcelRequire("cajOs")), (parcelRequire("hJBCI")));
})($a18748251e2fede6$exports, function(Data, EventHandler, Manipulator, SelectorEngine, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const Data__default = /*#__PURE__*/ _interopDefaultLegacy(Data);
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const SelectorEngine__default = /*#__PURE__*/ _interopDefaultLegacy(SelectorEngine);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getSelectorFromElement = (element)=>{
        const selector = getSelector(element);
        if (selector) return document.querySelector(selector) ? selector : null;
        return null;
    };
    const getElementFromSelector = (element)=>{
        const selector = getSelector(element);
        return selector ? document.querySelector(selector) : null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        // eslint-disable-next-line no-unused-expressions
        element.offsetHeight;
    };
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "collapse";
    const DATA_KEY = "bs.collapse";
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = ".data-api";
    const Default = {
        toggle: true,
        parent: null
    };
    const DefaultType = {
        toggle: "boolean",
        parent: "(null|element)"
    };
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_COLLAPSE = "collapse";
    const CLASS_NAME_COLLAPSING = "collapsing";
    const CLASS_NAME_COLLAPSED = "collapsed";
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = "collapse-horizontal";
    const WIDTH = "width";
    const HEIGHT = "height";
    const SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="collapse"]';
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class Collapse extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._isTransitioning = false;
            this._config = this._getConfig(config);
            this._triggerArray = [];
            const toggleList = SelectorEngine__default.default.find(SELECTOR_DATA_TOGGLE);
            for(let i = 0, len = toggleList.length; i < len; i++){
                const elem = toggleList[i];
                const selector = getSelectorFromElement(elem);
                const filterElement = SelectorEngine__default.default.find(selector).filter((foundElem)=>foundElem === this._element);
                if (selector !== null && filterElement.length) {
                    this._selector = selector;
                    this._triggerArray.push(elem);
                }
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
        static get Default() {
            return Default;
        }
        static get NAME() {
            return NAME;
        }
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let actives = [];
            let activesData;
            if (this._config.parent) {
                const children = SelectorEngine__default.default.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                actives = SelectorEngine__default.default.find(SELECTOR_ACTIVES, this._config.parent).filter((elem)=>!children.includes(elem)); // remove children if greater depth
            }
            const container = SelectorEngine__default.default.findOne(this._selector);
            if (actives.length) {
                const tempActiveData = actives.find((elem)=>container !== elem);
                activesData = tempActiveData ? Collapse.getInstance(tempActiveData) : null;
                if (activesData && activesData._isTransitioning) return;
            }
            const startEvent = EventHandler__default.default.trigger(this._element, EVENT_SHOW);
            if (startEvent.defaultPrevented) return;
            actives.forEach((elemActive)=>{
                if (container !== elemActive) Collapse.getOrCreateInstance(elemActive, {
                    toggle: false
                }).hide();
                if (!activesData) Data__default.default.set(elemActive, DATA_KEY, null);
            });
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
                this._element.style[dimension] = "";
                EventHandler__default.default.trigger(this._element, EVENT_SHOWN);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler__default.default.trigger(this._element, EVENT_HIDE);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
            const triggerArrayLength = this._triggerArray.length;
            for(let i = 0; i < triggerArrayLength; i++){
                const trigger = this._triggerArray[i];
                const elem = getElementFromSelector(trigger);
                if (elem && !this._isShown(elem)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler__default.default.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.style[dimension] = "";
            this._queueCallback(complete, this._element, true);
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW);
        }
        _getConfig(config) {
            config = {
                ...Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...config
            };
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = getElement(config.parent);
            typeCheckConfig(NAME, config, DefaultType);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = SelectorEngine__default.default.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            SelectorEngine__default.default.find(SELECTOR_DATA_TOGGLE, this._config.parent).filter((elem)=>!children.includes(elem)).forEach((element)=>{
                const selected = getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            });
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            triggerArray.forEach((elem)=>{
                if (isOpen) elem.classList.remove(CLASS_NAME_COLLAPSED);
                else elem.classList.add(CLASS_NAME_COLLAPSED);
                elem.setAttribute("aria-expanded", isOpen);
            });
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const _config = {};
                if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
    }
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ EventHandler__default.default.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
        const selector = getSelectorFromElement(this);
        const selectorElements = SelectorEngine__default.default.find(selector);
        selectorElements.forEach((element)=>{
            Collapse.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        });
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Collapse to jQuery only if jQuery is present
   */ defineJQueryPlugin(Collapse);
    return Collapse;
});


var $77f66b6d3012f4b5$exports = {};





/*!
  * Bootstrap dropdown.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $77f66b6d3012f4b5$exports = factory((parcelRequire("85GS9")), (parcelRequire("8EQUk")), (parcelRequire("9XHSj")), (parcelRequire("cajOs")), (parcelRequire("hJBCI")));
})($77f66b6d3012f4b5$exports, function(Popper, EventHandler, Manipulator, SelectorEngine, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        const n = Object.create(null);
        if (e) {
            for(const k in e)if (k !== "default") {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: ()=>e[k]
                });
            }
        }
        n.default = e;
        return Object.freeze(n);
    }
    const Popper__namespace = /*#__PURE__*/ _interopNamespace(Popper);
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const SelectorEngine__default = /*#__PURE__*/ _interopDefaultLegacy(SelectorEngine);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getElementFromSelector = (element)=>{
        const selector = getSelector(element);
        return selector ? document.querySelector(selector) : null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        return getComputedStyle(element).getPropertyValue("visibility") === "visible";
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    const noop = ()=>{};
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === "rtl";
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        let index = list.indexOf(activeElement); // if the element does not exist in the list return an element depending on the direction and if cycle is allowed
        if (index === -1) return list[!shouldGetNext && isCycleAllowed ? list.length - 1 : 0];
        const listLength = list.length;
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "dropdown";
    const DATA_KEY = "bs.dropdown";
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = ".data-api";
    const ESCAPE_KEY = "Escape";
    const SPACE_KEY = "Space";
    const TAB_KEY = "Tab";
    const ARROW_UP_KEY = "ArrowUp";
    const ARROW_DOWN_KEY = "ArrowDown";
    const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    const REGEXP_KEYDOWN = new RegExp(`${ARROW_UP_KEY}|${ARROW_DOWN_KEY}|${ESCAPE_KEY}`);
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY}${DATA_API_KEY}`;
    const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_DROPUP = "dropup";
    const CLASS_NAME_DROPEND = "dropend";
    const CLASS_NAME_DROPSTART = "dropstart";
    const CLASS_NAME_NAVBAR = "navbar";
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="dropdown"]';
    const SELECTOR_MENU = ".dropdown-menu";
    const SELECTOR_NAVBAR_NAV = ".navbar-nav";
    const SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    const PLACEMENT_TOP = isRTL() ? "top-end" : "top-start";
    const PLACEMENT_TOPEND = isRTL() ? "top-start" : "top-end";
    const PLACEMENT_BOTTOM = isRTL() ? "bottom-end" : "bottom-start";
    const PLACEMENT_BOTTOMEND = isRTL() ? "bottom-start" : "bottom-end";
    const PLACEMENT_RIGHT = isRTL() ? "left-start" : "right-start";
    const PLACEMENT_LEFT = isRTL() ? "right-start" : "left-start";
    const Default = {
        offset: [
            0,
            2
        ],
        boundary: "clippingParents",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null,
        autoClose: true
    };
    const DefaultType = {
        offset: "(array|string|function)",
        boundary: "(string|element)",
        reference: "(string|element|object)",
        display: "string",
        popperConfig: "(null|object|function)",
        autoClose: "(boolean|string)"
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class Dropdown extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
        }
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        toggle() {
            return this._isShown() ? this.hide() : this.show();
        }
        show() {
            if (isDisabled(this._element) || this._isShown(this._menu)) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            const showEvent = EventHandler__default.default.trigger(this._element, EVENT_SHOW, relatedTarget);
            if (showEvent.defaultPrevented) return;
            const parent = Dropdown.getParentFromElement(this._element); // Totally disable Popper for Dropdowns in Navbar
            if (this._inNavbar) Manipulator__default.default.setDataAttribute(this._menu, "popper", "none");
            else this._createPopper(parent);
             // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && !parent.closest(SELECTOR_NAVBAR_NAV)) [].concat(...document.body.children).forEach((elem)=>EventHandler__default.default.on(elem, "mouseover", noop));
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            this._menu.classList.add(CLASS_NAME_SHOW);
            this._element.classList.add(CLASS_NAME_SHOW);
            EventHandler__default.default.trigger(this._element, EVENT_SHOWN, relatedTarget);
        }
        hide() {
            if (isDisabled(this._element) || !this._isShown(this._menu)) return;
            const relatedTarget = {
                relatedTarget: this._element
            };
            this._completeHide(relatedTarget);
        }
        dispose() {
            if (this._popper) this._popper.destroy();
            super.dispose();
        }
        update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper) this._popper.update();
        }
        _completeHide(relatedTarget) {
            const hideEvent = EventHandler__default.default.trigger(this._element, EVENT_HIDE, relatedTarget);
            if (hideEvent.defaultPrevented) return;
             // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) [].concat(...document.body.children).forEach((elem)=>EventHandler__default.default.off(elem, "mouseover", noop));
            if (this._popper) this._popper.destroy();
            this._menu.classList.remove(CLASS_NAME_SHOW);
            this._element.classList.remove(CLASS_NAME_SHOW);
            this._element.setAttribute("aria-expanded", "false");
            Manipulator__default.default.removeDataAttribute(this._menu, "popper");
            EventHandler__default.default.trigger(this._element, EVENT_HIDDEN, relatedTarget);
        }
        _getConfig(config) {
            config = {
                ...this.constructor.Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...config
            };
            typeCheckConfig(NAME, config, this.constructor.DefaultType);
            if (typeof config.reference === "object" && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
            throw new TypeError(`${NAME.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
            return config;
        }
        _createPopper(parent) {
            if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
            let referenceElement = this._element;
            if (this._config.reference === "parent") referenceElement = parent;
            else if (isElement(this._config.reference)) referenceElement = getElement(this._config.reference);
            else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
            const popperConfig = this._getPopperConfig();
            const isDisplayStatic = popperConfig.modifiers.find((modifier)=>modifier.name === "applyStyles" && modifier.enabled === false);
            this._popper = Popper__namespace.createPopper(referenceElement, this._menu, popperConfig);
            if (isDisplayStatic) Manipulator__default.default.setDataAttribute(this._menu, "popper", "static");
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW);
        }
        _getMenuElement() {
            return SelectorEngine__default.default.next(this._element, SELECTOR_MENU)[0];
        }
        _getPlacement() {
            const parentDropdown = this._element.parentNode;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
            if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
             // We need to trim the value because custom properties can also include spaces
            const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
            if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
        }
        _detectNavbar() {
            return this._element.closest(`.${CLASS_NAME_NAVBAR}`) !== null;
        }
        _getOffset() {
            const { offset: offset } = this._config;
            if (typeof offset === "string") return offset.split(",").map((val)=>Number.parseInt(val, 10));
            if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
            return offset;
        }
        _getPopperConfig() {
            const defaultBsPopperConfig = {
                placement: this._getPlacement(),
                modifiers: [
                    {
                        name: "preventOverflow",
                        options: {
                            boundary: this._config.boundary
                        }
                    },
                    {
                        name: "offset",
                        options: {
                            offset: this._getOffset()
                        }
                    }
                ]
            }; // Disable Popper if we have a static display
            if (this._config.display === "static") defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
            return {
                ...defaultBsPopperConfig,
                ...typeof this._config.popperConfig === "function" ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig
            };
        }
        _selectMenuItem({ key: key, target: target }) {
            const items = SelectorEngine__default.default.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(isVisible);
            if (!items.length) return;
             // if target isn't included in items (e.g. when expanding the dropdown)
            // allow cycling to get the last item in case key equals ARROW_UP_KEY
            getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus();
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Dropdown.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
        static clearMenus(event) {
            if (event && (event.button === RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== TAB_KEY)) return;
            const toggles = SelectorEngine__default.default.find(SELECTOR_DATA_TOGGLE);
            for(let i = 0, len = toggles.length; i < len; i++){
                const context = Dropdown.getInstance(toggles[i]);
                if (!context || context._config.autoClose === false) continue;
                if (!context._isShown()) continue;
                const relatedTarget = {
                    relatedTarget: context._element
                };
                if (event) {
                    const composedPath = event.composedPath();
                    const isMenuTarget = composedPath.includes(context._menu);
                    if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
                     // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                    if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === TAB_KEY || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                    if (event.type === "click") relatedTarget.clickEvent = event;
                }
                context._completeHide(relatedTarget);
            }
        }
        static getParentFromElement(element) {
            return getElementFromSelector(element) || element.parentNode;
        }
        static dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.key === SPACE_KEY || event.key !== ESCAPE_KEY && (event.key !== ARROW_DOWN_KEY && event.key !== ARROW_UP_KEY || event.target.closest(SELECTOR_MENU)) : !REGEXP_KEYDOWN.test(event.key)) return;
            const isActive = this.classList.contains(CLASS_NAME_SHOW);
            if (!isActive && event.key === ESCAPE_KEY) return;
            event.preventDefault();
            event.stopPropagation();
            if (isDisabled(this)) return;
            const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE) ? this : SelectorEngine__default.default.prev(this, SELECTOR_DATA_TOGGLE)[0];
            const instance = Dropdown.getOrCreateInstance(getToggleButton);
            if (event.key === ESCAPE_KEY) {
                instance.hide();
                return;
            }
            if (event.key === ARROW_UP_KEY || event.key === ARROW_DOWN_KEY) {
                if (!isActive) instance.show();
                instance._selectMenuItem(event);
                return;
            }
            if (!isActive || event.key === SPACE_KEY) Dropdown.clearMenus();
        }
    }
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ EventHandler__default.default.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE, Dropdown.dataApiKeydownHandler);
    EventHandler__default.default.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler__default.default.on(document, EVENT_CLICK_DATA_API, Dropdown.clearMenus);
    EventHandler__default.default.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler__default.default.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Dropdown to jQuery only if jQuery is present
   */ defineJQueryPlugin(Dropdown);
    return Dropdown;
});


var $1651623aec7141a8$exports = {};




/*!
  * Bootstrap scrollspy.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $1651623aec7141a8$exports = factory((parcelRequire("8EQUk")), (parcelRequire("9XHSj")), (parcelRequire("cajOs")), (parcelRequire("hJBCI")));
})($1651623aec7141a8$exports, function(EventHandler, Manipulator, SelectorEngine, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const SelectorEngine__default = /*#__PURE__*/ _interopDefaultLegacy(SelectorEngine);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getSelectorFromElement = (element)=>{
        const selector = getSelector(element);
        if (selector) return document.querySelector(selector) ? selector : null;
        return null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const getElement = (obj)=>{
        if (isElement(obj)) // it's a jQuery object or a node element
        return obj.jquery ? obj[0] : obj;
        if (typeof obj === "string" && obj.length > 0) return document.querySelector(obj);
        return null;
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "scrollspy";
    const DATA_KEY = "bs.scrollspy";
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = ".data-api";
    const Default = {
        offset: 10,
        method: "auto",
        target: ""
    };
    const DefaultType = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    };
    const EVENT_ACTIVATE = `activate${EVENT_KEY}`;
    const EVENT_SCROLL = `scroll${EVENT_KEY}`;
    const EVENT_LOAD_DATA_API = `load${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    const CLASS_NAME_ACTIVE = "active";
    const SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
    const SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    const SELECTOR_NAV_LINKS = ".nav-link";
    const SELECTOR_NAV_ITEMS = ".nav-item";
    const SELECTOR_LIST_ITEMS = ".list-group-item";
    const SELECTOR_LINK_ITEMS = `${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}, .${CLASS_NAME_DROPDOWN_ITEM}`;
    const SELECTOR_DROPDOWN = ".dropdown";
    const SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    const METHOD_OFFSET = "offset";
    const METHOD_POSITION = "position";
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class ScrollSpy extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._scrollElement = this._element.tagName === "BODY" ? window : this._element;
            this._config = this._getConfig(config);
            this._offsets = [];
            this._targets = [];
            this._activeTarget = null;
            this._scrollHeight = 0;
            EventHandler__default.default.on(this._scrollElement, EVENT_SCROLL, ()=>this._process());
            this.refresh();
            this._process();
        }
        static get Default() {
            return Default;
        }
        static get NAME() {
            return NAME;
        }
        refresh() {
            const autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
            const offsetMethod = this._config.method === "auto" ? autoMethod : this._config.method;
            const offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
            this._offsets = [];
            this._targets = [];
            this._scrollHeight = this._getScrollHeight();
            const targets = SelectorEngine__default.default.find(SELECTOR_LINK_ITEMS, this._config.target);
            targets.map((element)=>{
                const targetSelector = getSelectorFromElement(element);
                const target = targetSelector ? SelectorEngine__default.default.findOne(targetSelector) : null;
                if (target) {
                    const targetBCR = target.getBoundingClientRect();
                    if (targetBCR.width || targetBCR.height) return [
                        Manipulator__default.default[offsetMethod](target).top + offsetBase,
                        targetSelector
                    ];
                }
                return null;
            }).filter((item)=>item).sort((a, b)=>a[0] - b[0]).forEach((item)=>{
                this._offsets.push(item[0]);
                this._targets.push(item[1]);
            });
        }
        dispose() {
            EventHandler__default.default.off(this._scrollElement, EVENT_KEY);
            super.dispose();
        }
        _getConfig(config) {
            config = {
                ...Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...typeof config === "object" && config ? config : {}
            };
            config.target = getElement(config.target) || document.documentElement;
            typeCheckConfig(NAME, config, DefaultType);
            return config;
        }
        _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        }
        _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        }
        _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        }
        _process() {
            const scrollTop = this._getScrollTop() + this._config.offset;
            const scrollHeight = this._getScrollHeight();
            const maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
            if (this._scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                const target = this._targets[this._targets.length - 1];
                if (this._activeTarget !== target) this._activate(target);
                return;
            }
            if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;
                this._clear();
                return;
            }
            for(let i = this._offsets.length; i--;){
                const isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === "undefined" || scrollTop < this._offsets[i + 1]);
                if (isActiveTarget) this._activate(this._targets[i]);
            }
        }
        _activate(target) {
            this._activeTarget = target;
            this._clear();
            const queries = SELECTOR_LINK_ITEMS.split(",").map((selector)=>`${selector}[data-bs-target="${target}"],${selector}[href="${target}"]`);
            const link = SelectorEngine__default.default.findOne(queries.join(","), this._config.target);
            link.classList.add(CLASS_NAME_ACTIVE);
            if (link.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) SelectorEngine__default.default.findOne(SELECTOR_DROPDOWN_TOGGLE, link.closest(SELECTOR_DROPDOWN)).classList.add(CLASS_NAME_ACTIVE);
            else SelectorEngine__default.default.parents(link, SELECTOR_NAV_LIST_GROUP).forEach((listGroup)=>{
                // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                SelectorEngine__default.default.prev(listGroup, `${SELECTOR_NAV_LINKS}, ${SELECTOR_LIST_ITEMS}`).forEach((item)=>item.classList.add(CLASS_NAME_ACTIVE)); // Handle special case when .nav-link is inside .nav-item
                SelectorEngine__default.default.prev(listGroup, SELECTOR_NAV_ITEMS).forEach((navItem)=>{
                    SelectorEngine__default.default.children(navItem, SELECTOR_NAV_LINKS).forEach((item)=>item.classList.add(CLASS_NAME_ACTIVE));
                });
            });
            EventHandler__default.default.trigger(this._scrollElement, EVENT_ACTIVATE, {
                relatedTarget: target
            });
        }
        _clear() {
            SelectorEngine__default.default.find(SELECTOR_LINK_ITEMS, this._config.target).filter((node)=>node.classList.contains(CLASS_NAME_ACTIVE)).forEach((node)=>node.classList.remove(CLASS_NAME_ACTIVE));
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const data = ScrollSpy.getOrCreateInstance(this, config);
                if (typeof config !== "string") return;
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            });
        }
    }
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ EventHandler__default.default.on(window, EVENT_LOAD_DATA_API, ()=>{
        SelectorEngine__default.default.find(SELECTOR_DATA_SPY).forEach((spy)=>new ScrollSpy(spy));
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .ScrollSpy to jQuery only if jQuery is present
   */ defineJQueryPlugin(ScrollSpy);
    return ScrollSpy;
});


var $ed488ca406b02692$exports = {};



/*!
  * Bootstrap toast.js v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $ed488ca406b02692$exports = factory((parcelRequire("8EQUk")), (parcelRequire("9XHSj")), (parcelRequire("hJBCI")));
})($ed488ca406b02692$exports, function(EventHandler, Manipulator, BaseComponent) {
    "use strict";
    const _interopDefaultLegacy = (e)=>e && typeof e === "object" && "default" in e ? e : {
            default: e
        };
    const EventHandler__default = /*#__PURE__*/ _interopDefaultLegacy(EventHandler);
    const Manipulator__default = /*#__PURE__*/ _interopDefaultLegacy(Manipulator);
    const BaseComponent__default = /*#__PURE__*/ _interopDefaultLegacy(BaseComponent);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const toType = (obj)=>{
        if (obj === null || obj === undefined) return `${obj}`;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttr = element.getAttribute("href"); // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttr || !hrefAttr.includes("#") && !hrefAttr.startsWith(".")) return null;
             // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttr.includes("#") && !hrefAttr.startsWith("#")) hrefAttr = `#${hrefAttr.split("#")[1]}`;
            selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : null;
        }
        return selector;
    };
    const getElementFromSelector = (element)=>{
        const selector = getSelector(element);
        return selector ? document.querySelector(selector) : null;
    };
    const isElement = (obj)=>{
        if (!obj || typeof obj !== "object") return false;
        if (typeof obj.jquery !== "undefined") obj = obj[0];
        return typeof obj.nodeType !== "undefined";
    };
    const typeCheckConfig = (componentName, config, configTypes)=>{
        Object.keys(configTypes).forEach((property)=>{
            const expectedTypes = configTypes[property];
            const value = config[property];
            const valueType = value && isElement(value) ? "element" : toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        });
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        // eslint-disable-next-line no-unused-expressions
        element.offsetHeight;
    };
    const getjQuery = ()=>{
        const { jQuery: jQuery } = window;
        if (jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                DOMContentLoadedCallbacks.forEach((callback)=>callback());
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const enableDismissTrigger = (component, method = "hide")=>{
        const clickEvent = `click.dismiss${component.EVENT_KEY}`;
        const name = component.NAME;
        EventHandler__default.default.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
            if ([
                "A",
                "AREA"
            ].includes(this.tagName)) event.preventDefault();
            if (isDisabled(this)) return;
            const target = getElementFromSelector(this) || this.closest(`.${name}`);
            const instance = component.getOrCreateInstance(target); // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
            instance[method]();
        });
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): toast.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ const NAME = "toast";
    const DATA_KEY = "bs.toast";
    const EVENT_KEY = `.${DATA_KEY}`;
    const EVENT_MOUSEOVER = `mouseover${EVENT_KEY}`;
    const EVENT_MOUSEOUT = `mouseout${EVENT_KEY}`;
    const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
    const EVENT_FOCUSOUT = `focusout${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const CLASS_NAME_FADE = "fade";
    const CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_SHOWING = "showing";
    const DefaultType = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    const Default = {
        animation: true,
        autohide: true,
        delay: 5000
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ class Toast extends BaseComponent__default.default {
        constructor(element, config){
            super(element);
            this._config = this._getConfig(config);
            this._timeout = null;
            this._hasMouseInteraction = false;
            this._hasKeyboardInteraction = false;
            this._setListeners();
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get Default() {
            return Default;
        }
        static get NAME() {
            return NAME;
        }
        show() {
            const showEvent = EventHandler__default.default.trigger(this._element, EVENT_SHOW);
            if (showEvent.defaultPrevented) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            const complete = ()=>{
                this._element.classList.remove(CLASS_NAME_SHOWING);
                EventHandler__default.default.trigger(this._element, EVENT_SHOWN);
                this._maybeScheduleHide();
            };
            this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated
            reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOW);
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        hide() {
            if (!this._element.classList.contains(CLASS_NAME_SHOW)) return;
            const hideEvent = EventHandler__default.default.trigger(this._element, EVENT_HIDE);
            if (hideEvent.defaultPrevented) return;
            const complete = ()=>{
                this._element.classList.add(CLASS_NAME_HIDE); // @deprecated
                this._element.classList.remove(CLASS_NAME_SHOWING);
                this._element.classList.remove(CLASS_NAME_SHOW);
                EventHandler__default.default.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.classList.add(CLASS_NAME_SHOWING);
            this._queueCallback(complete, this._element, this._config.animation);
        }
        dispose() {
            this._clearTimeout();
            if (this._element.classList.contains(CLASS_NAME_SHOW)) this._element.classList.remove(CLASS_NAME_SHOW);
            super.dispose();
        }
        _getConfig(config) {
            config = {
                ...Default,
                ...Manipulator__default.default.getDataAttributes(this._element),
                ...typeof config === "object" && config ? config : {}
            };
            typeCheckConfig(NAME, config, this.constructor.DefaultType);
            return config;
        }
        _maybeScheduleHide() {
            if (!this._config.autohide) return;
            if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
            this._timeout = setTimeout(()=>{
                this.hide();
            }, this._config.delay);
        }
        _onInteraction(event, isInteracting) {
            switch(event.type){
                case "mouseover":
                case "mouseout":
                    this._hasMouseInteraction = isInteracting;
                    break;
                case "focusin":
                case "focusout":
                    this._hasKeyboardInteraction = isInteracting;
                    break;
            }
            if (isInteracting) {
                this._clearTimeout();
                return;
            }
            const nextElement = event.relatedTarget;
            if (this._element === nextElement || this._element.contains(nextElement)) return;
            this._maybeScheduleHide();
        }
        _setListeners() {
            EventHandler__default.default.on(this._element, EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
            EventHandler__default.default.on(this._element, EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
            EventHandler__default.default.on(this._element, EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
            EventHandler__default.default.on(this._element, EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
        }
        _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        }
        static jQueryInterface(config) {
            return this.each(function() {
                const data = Toast.getOrCreateInstance(this, config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config](this);
                }
            });
        }
    }
    enableDismissTrigger(Toast);
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Toast to jQuery only if jQuery is present
   */ defineJQueryPlugin(Toast);
    return Toast;
});


// Activate Bootstrap scrollspy on the main nav element
const $59e9f1aad8fc74e0$var$sideNav = document.body.querySelector("#sidenav");
if ($59e9f1aad8fc74e0$var$sideNav) new (0, (/*@__PURE__*/$parcel$interopDefault($1651623aec7141a8$exports)))(document.body, {
    target: "#sidenav",
    offset: 74
});
// Collapse responsive navbar when toggler is visible
const $59e9f1aad8fc74e0$var$navbar = document.body.querySelector("#navbarResponsive");
const $59e9f1aad8fc74e0$var$navbarToggler = document.body.querySelector(".navbar-toggler");
const $59e9f1aad8fc74e0$var$navBrand = [].slice.call(document.querySelectorAll(".navbar-brand"));
const $59e9f1aad8fc74e0$var$responsiveNavItems = [].slice.call(document.querySelectorAll("#navbarResponsive .nav-link"));
[
    ...$59e9f1aad8fc74e0$var$navBrand,
    ...$59e9f1aad8fc74e0$var$responsiveNavItems
].map(function(responsiveNavItem) {
    responsiveNavItem.addEventListener("click", ()=>{
        if (window.getComputedStyle($59e9f1aad8fc74e0$var$navbarToggler).display !== "none" && $59e9f1aad8fc74e0$var$navbar.classList.contains("show")) $59e9f1aad8fc74e0$var$navbarToggler.click();
    });
});
// Hide Hash Fragment when scrolling to the top
// document.addEventListener('scroll', () => {
//     if (window.scrollY === 0) {
//         window.history.replaceState(null, null, ' ');
//     }
// });
// Show E-mail Toast
const $59e9f1aad8fc74e0$var$mailToast = document.body.querySelector("#about #mail-toast .toast");
const $59e9f1aad8fc74e0$var$bsMailToast = new (0, (/*@__PURE__*/$parcel$interopDefault($ed488ca406b02692$exports)))($59e9f1aad8fc74e0$var$mailToast);
function $59e9f1aad8fc74e0$var$copyMail() {
    navigator.clipboard.writeText(atob("bWFpbHRvOk1hSWwuU2hSRXlBZ0BHbUFpTC5jT20=").toLowerCase().substring(7));
    $59e9f1aad8fc74e0$var$mailToast.children[0].textContent = "E-mail Address Copied!";
    $59e9f1aad8fc74e0$var$bsMailToast.show();
}
document.getElementById("copy-mail").addEventListener("click", $59e9f1aad8fc74e0$var$copyMail);

})();
//# sourceMappingURL=scripts.4dbe6a28.js.map
